import { Component, h, Prop, Host, State } from "@stencil/core";

@Component({
    tag: "ux-w-header",
    styleUrl: "header.scss",
    shadow: false
})
export class Header {
    /** url for the Link next to the title */
    @Prop() url: string = "";
    /** text for the title attribute of the link */
    @Prop() linkTitle: string = "";
    /** sets bool wether widget has a menu */
    @Prop() hasMenu: boolean = false;
    /** wether the widget header menu is visible */
    @State() menuVisible: boolean = false;

    private openMenu(e) {
        e.preventDefault();
        const el = e.target;
        el.classList.toggle("is-open");
        this.menuVisible = !this.menuVisible;
    }

    render() {
        const baseClass = "ux-w-header";

        return (
            <Host class={baseClass}>
                <slot name="headline" />
                {this.url !== "" && (
                    <a href={this.url} title={this.linkTitle}>
                        <ux-icon name="arrow-small-right" />
                    </a>
                )}
                &nbsp;
                {this.hasMenu && (
                    <div class={`${baseClass}__menu`}>
                        <a
                            href="#"
                            class={`${baseClass}__menu-link`}
                            onClick={(e) => this.openMenu(e)}
                        >
                            <ux-icon name={"cog"} />
                        </a>

                        <div
                            class={`${baseClass}__menu-content ${
                                this.menuVisible ? "is-visible" : "is-hidden"
                            }`}
                        >
                            <slot name="menu" />
                        </div>
                    </div>
                )}
            </Host>
        );
    }
}
